import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdfsReloginInterceptor } from '@eastbanctechru/ng-adfs-relogin-interceptor';
import { CheckForUndefinedFieldsInterceptor } from './check-for-undefined-fields.interceptor';
import { ConvertDatesToStringsInterceptor } from './convert-dates-to-strings.interceptor';
import { DisplayServerErrorInterceptor } from './display-server-error.interceptor';
import { DisplayUnauthorizedErrorInterceptor } from './display-unauthorized-error.interceptor';
import { SetAjaxHeaderInterceptor } from './set-ajax-header.interceptor';
import { SetCypressHeaderInterceptor } from './set-cypress-header.interceptor';
import { SetNoCacheHeaderInterceptor } from './set-no-cache-header.interceptor';
import { SetSelectedAgencyHeaderInterceptor } from './set-selected-agency-header.interceptor';
import { DisplayConcurrencyConflictErrorInterceptor } from './display-concurrency-conflict-error.interceptor';

// ВНИМАНИЕ!
// Порядок объявления интерцепторов влияет на порядок их вызова в цепочке обработки запроса.
// Менять порядок не рекомендуется, либо делать это только, если есть понимание на что это может повлиять.
export const APP_INTERCEPTORS = [
    { provide: HTTP_INTERCEPTORS, useClass: CheckForUndefinedFieldsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SetAjaxHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SetNoCacheHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ConvertDatesToStringsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SetSelectedAgencyHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DisplayServerErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DisplayConcurrencyConflictErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DisplayUnauthorizedErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AdfsReloginInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SetCypressHeaderInterceptor, multi: true }
];
